module.exports = __webpack_public_path__ + "img/line-defeat.c5949775.svg";